/**
 * @param {unknown[]} list
 */
export function seedExchangeIds(list) {
  /** @type {null | { exchangeId: string, versionIndex: number }} */
  let current = null

  return (Array.isArray(list) ? list : []).map((m) => {
    if (!m || typeof m !== 'object') return m
    if (m.exchangeId && typeof m.versionIndex === 'number') {
      if (m.role === 'user') current = { exchangeId: m.exchangeId, versionIndex: m.versionIndex }
      if (m.role === 'assistant' && typeof m.assistantVersionIndex !== 'number') {
        return { ...m, assistantVersionIndex: 0 }
      }
      return m
    }

    if (m.role === 'user') {
      const exchangeId = m.id
      const versionIndex = 0
      current = { exchangeId, versionIndex }
      return { ...m, exchangeId, versionIndex }
    }

    if (m.role === 'assistant') {
      const exchangeId = current?.exchangeId ?? m.id
      const versionIndex = current?.versionIndex ?? 0
      return { ...m, exchangeId, versionIndex, assistantVersionIndex: 0 }
    }

    return m
  })
}
